import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { TableList, Typography } from 'seagull';
import ServicePickerPriceLabel from "./ServicePickerPriceLabel";
import styles from "./ServicePicker.module.scss";
import { scrollIntoView } from "../../../infra/utils";
import { serviceTemplateModel } from "../../../models";
import { getUnitName } from "../../../utils/unit-name.utils";
import { recurrencePeriodLabels } from "../../../constants";
export default function ServicePickerRow(_ref) {
  let {
    service,
    isNew,
    onSelectionChange
  } = _ref;
  const canHaveCap = serviceTemplateModel.isVariablePrice(service.cost);
  const unitCap = serviceTemplateModel.unitCap(service);
  const rowRef = useRef(null);
  const [addPulse, setAddPulse] = useState(false);
  useEffect(() => {
    if (isNew) {
      // cypress version 12.11 can't handle a smooth behavior. Please remove this ugly hack whenn upgrading cypress
      rowRef.current && scrollIntoView(rowRef.current, {
        block: 'end',
        disableScrollAnimation: IS_CYPRESS
      });
      setTimeout(() => setAddPulse(true), 300); // Pulse should start after scroll animation ends.
    } else {
      setAddPulse(false);
    }
  }, [isNew]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    ref: rowRef,
    as: "button",
    onClick: onSelectionChange != null ? () => onSelectionChange() : () => null,
    rowId: service.id,
    addPulse: addPulse,
    "data-testid": "uneditable-service-picker-row",
    "data-name": service.name,
    items: [{
      value: /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        weight: "normal",
        className: classNames(styles.formElement, styles.absolutePosition, styles.withBackground),
        "data-testid": "uneditable-service-picker-row-name"
      }, service.name)
    }, {
      value: /*#__PURE__*/React.createElement(ServicePickerPriceLabel, {
        service: service
      })
    }, {
      value: /*#__PURE__*/React.createElement(Typography, null, serviceTemplateModel.isRecurring(service.billing) ? recurrencePeriodLabels[service.billing.recurrencePeriod] : 'One-time')
    }, {
      value: /*#__PURE__*/React.createElement(Typography, null, serviceTemplateModel.isManual(service.billing) ? 'Manual' : 'Automatic')
    }, {
      value: canHaveCap && /*#__PURE__*/React.createElement(Typography, {
        className: styles.preapproved
      }, /*#__PURE__*/React.createElement(Typography, {
        className: styles.preapprovedInput,
        "data-testid": "uneditable-service-picker-row-cap"
      }, unitCap ? unitCap.toNumber() : ''), !!unitCap && unitCap.greaterThan(0) && /*#__PURE__*/React.createElement(Typography, {
        className: styles.capUnitName,
        ellipsis: true,
        skin: "secondary"
      }, getUnitName(serviceTemplateModel.unitName(service), {
        short: true
      })))
    }]
  });
}